/* eslint-disable sonarjs/no-duplicate-string */
import React from 'react';

import { BaseCard, Box, ComposedElement, Spacer, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { ComposableTextLink, DisplayCost } from '@components';
import { rem } from '@helpers';

import { useCostSummaryHelper } from './costSummary.helper';

export const CostSummary: React.FC = () => {
	const { resources, titleLabel, acceptMasterOrVisaCards, solutionIntegrated, selectedAccountIntegratedSolution } =
		useCostSummaryHelper();

	return (
		<BaseCard width={'100%'}>
			<Box styles={{ flexDirection: 'column', width: '100%' }}>
				<Box styles={{ height: rem(30) }}>
					<ComposedElement
						icon={{
							source: resources.iconMbway,
						}}
					/>
					<Spacer horizontal={rem(16)} />
					<ComposedElement
						icon={{
							source: resources.iconAtm,
						}}
					/>
					{acceptMasterOrVisaCards && (
						<>
							<Spacer horizontal={rem(16)} />
							<ComposedElement icon={{ source: resources.iconVisa }} />
							<Spacer horizontal={rem(16)} />
							<ComposedElement icon={{ source: resources.iconMastercard }} />
						</>
					)}
				</Box>
				<Spacer vertical={rem(16)} />
				<Box styles={{ width: '100%' }}>
					<Box styles={{ width: '100%', alignItems: 'center' }}>
						<Box styles={{ width: '100%', justifyContent: 'left' }}>
							<Typography appearance="subtitle-100-04">{titleLabel}</Typography>
						</Box>
						<Box styles={{ width: '100%', justifyContent: 'right' }}>
							{selectedAccountIntegratedSolution ? (
								<DisplayCost cost={resources.valueWithPromotion} appearance={'promotionalSecondary'} />
							) : (
								<DisplayCost cost={resources.valueWithoutPromotion} appearance={'tertiary'} />
							)}
						</Box>
					</Box>
				</Box>
				<Spacer vertical={rem(16)} />
				{selectedAccountIntegratedSolution ? (
					<Box styles={{ flexDirection: 'column', gap: rem(8) }}>
						<ComposableTextLink
							typography={{ text: resources.solutionIntegrated.paymentTax, appearance: 'body-75-02' }}
							link={{
								text: resources.solutionIntegrated.paymentTaxLink,
								url: resources.solutionIntegrated.paymentTaxUrl,
								appearance: 'body-75-03',
								colorToken: 'interaction-01-100',
							}}
						/>
					</Box>
				) : (
					<Box styles={{ flexDirection: 'column', gap: rem(8) }}>
						<ComposableTextLink
							typography={{ text: resources.noSolutionIntegrated.paymentTax, appearance: 'body-75-02' }}
							link={{
								text: resources.noSolutionIntegrated.paymentTaxLink,
								url: resources.noSolutionIntegrated.paymentTaxUrl,
								appearance: 'body-75-03',
								colorToken: 'interaction-01-100',
							}}
						/>
						<ComposableTextLink
							typography={{
								text: resources.noSolutionIntegrated.solutionMCorporate,
								appearance: 'microcopy-75-02',
								colorToken: 'interaction-03-90',
							}}
							link={{
								text: resources.noSolutionIntegrated.solutionMCorporateLink,
								url: resources.noSolutionIntegrated.solutionMCorporateUrl,
								targetType: 'popup',
								appearance: 'body-75-03',
								colorToken: 'interaction-01-100',
							}}
						/>
					</Box>
				)}
			</Box>
		</BaseCard>
	);
};
